module.exports = __webpack_public_path__ + "static/media/left.b533d806.png";